import { useQuery } from '@tanstack/react-query'

import { apiClient } from '@/lib/api-client'

import type { ListAffiliateWithdrawalsResponse } from './list-affiliate-withdrawals.types'

const listAffiliateWithdrawals =
  async (): Promise<ListAffiliateWithdrawalsResponse> => {
    const response = await apiClient.get<ListAffiliateWithdrawalsResponse>(
      '/v1/affiliation/withdrawals',
    )
    return response.data
  }

export const useListAffiliateWithdrawals = () => {
  return useQuery({
    queryKey: ['affiliate-withdrawals'],
    queryFn: () => listAffiliateWithdrawals(),
  })
}
